import(/* webpackMode: "eager" */ "/app/src/app/loading.tsx")